export const host = `${
  process.env.NEXT_PUBLIC_HOST.includes('https://')
    ? process.env.NEXT_PUBLIC_HOST
    : `https://${process.env.NEXT_PUBLIC_HOST}`
}`;

// Function to generate BreadcrumbList JSON-LD
export function generateBreadcrumbList(currentPageUrl) {
  const breadcrumbs = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [],
  };

  // Add home page as the first item
  breadcrumbs.itemListElement.push({
    '@type': 'ListItem',
    position: breadcrumbs.itemListElement.length + 1,
    item: {
      '@id': host,
      name: 'Home Page',
    },
  });

  // Split the path of the current page URL and add each part as a breadcrumb item
  const pathParts = new URL(currentPageUrl).pathname.split('/').filter(Boolean);
  let cumulativePath = host;

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < pathParts.length; i++) {
    if (pathParts[i] === 'article') {
      // eslint-disable-next-line no-continue
      continue;
    }
    cumulativePath += `/${pathParts[i]}/`;

    const nameRoot = pathParts[i].replaceAll('-', ' ');
    const name = nameRoot.substring(0, 1).toUpperCase() + nameRoot.substring(1);

    const breadcrumbItem = {
      '@type': 'ListItem',
      position: breadcrumbs.itemListElement.length + 1,
      item: {
        '@type': 'WebPage',
        name,
      },
    };
    if (i !== pathParts.length - 1) {
      breadcrumbItem.item['@id'] = cumulativePath;
    }

    breadcrumbs.itemListElement.push(breadcrumbItem);
  }

  return [breadcrumbs];
}

export function generateBlogPostUrl(type, slug) {
  const prefix = `${host}/${type ? 'blog/' : 'blog/article/'}`;
  return `${prefix}${slug}`;
}

export default {};
